/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeldropplaceholder2Inputs */

const en_channeldropplaceholder2 = /** @type {(inputs: Channeldropplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a drop...`)
};

const de_channeldropplaceholder2 = /** @type {(inputs: Channeldropplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop auswählen…`)
};

/**
* | output |
* | --- |
* | "Pick a drop..." |
*
* @param {Channeldropplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeldropplaceholder2 = /** @type {((inputs?: Channeldropplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeldropplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeldropplaceholder2(inputs)
	return de_channeldropplaceholder2(inputs)
});
export { channeldropplaceholder2 as "channelDropPlaceholder" }